import bodybuilder from 'bodybuilder';
import { each, snakeCase, toLower } from 'lodash'

export function filtersToEsQuery(filters){
  const esQuery = bodybuilder();
  each(filters, function(value, key){
    if(Boolean(value)){
      let snakeKey = snakeCase(key);
      switch(key){
        case 'maxAge':
          const MIN_POSSIBLE_AGE = 0;
          esQuery.filter('range', snakeKey, { gte: value });
          break;
        case 'minAge':
          const MAX_POSSIBLE_AGE = 2000;
          esQuery.filter('range', snakeKey, { lte: value } );
          break;
        case 'specialtyNames':
          esQuery.filter('term', snakeKey, value);
          break;
        case 'firstName':
          esQuery.query("wildcard", snakeKey, toLower(value)+"*");
          break;
        case 'lastName':
          esQuery.query("wildcard", snakeKey, toLower(value)+"*");
          break;
        case 'username':
          esQuery.query("wildcard", snakeKey, toLower(value)+"*");
          break;
        default:  
          if(Array.isArray(value)){
            each(value, function(i){
              if(Boolean(i)){
                esQuery.query("match", snakeKey, i);
              }
            });
          }else{
            esQuery.query("match", snakeKey, value);
          }
          break;
      }
    }else{
      return null;
    }
  });
  esQuery.filter('term', 'valid_db_record', true);
  esQuery.size(50);
  return esQuery.build();
}
